<template>
  <div class="rating">
    <ul class="list">
      <li
        v-for="star in maxStars"
        :key="star"
        :class="{ active: star <= stars }"
        class="star"
        @click="rate(star)"
      >
        <icon id="star" scale="1.9" :name="star <= stars ? 'star' : 'star-o'" />
      </li>
    </ul>
    <span v-if="hasCounter" style="padding-left: 0.5rem; padding-bottom: 0.5rem;">({{ stars }}/{{ maxStars }})</span>
  </div>
</template>

<script>
import "vue-awesome/icons/star";
import "vue-awesome/icons/star-o";
const store_utils = require("@/store_utils").default;
import Icon from "vue-awesome/components/Icon";
import { customLogger } from "@/utils";

export default {
  components: { Icon },
  props: {
    grade: {
      type: Number,
      required: true,
    },
    maxStars: {
      type: Number,
      default: 10,
    },
    hasCounter: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      stars: this.grade,
      rated: this.disabled,
    };
  },
  methods: {
    async rate(star) {
      try {
        if (typeof star === "number" && star <= this.maxStars && star >= 0 && !this.rated) {
          this.stars = this.stars === star ? star - 1 : star;
          this.rated = true;
        
          await this.$store.dispatch("GIVE_FEEDBACK", star);
          store_utils.emit_message({
            message: this.$t("rating.note", { 0: star }),
            dialogflow: true,
            commit: true,
            sender: "self",
          });
          
          store_utils.emit_message({
            message: this.$t("rating.response"),
            dialogflow: true,
            commit: true,
            sender: "bot",
          });
        }

      } catch (err) {
        customLogger(err);
        return err;
      }
    }
  },
};
</script>
